"use client"

import { LazyMotion, domMax } from "framer-motion"
import type { ReactNode } from "react"

export default function MotionProvider({ children }: { children: ReactNode }) {
    return (
        <LazyMotion features={domMax}>
            {children}
        </LazyMotion>
    )
}
